import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./LanguageContext";

import Navigationbar from "./Navigationbar";
import Snowfall from "./Snowfall";
import Social from "./Social";
import Apps from "./Apps";
import Contact from "./Contact";
import TechProfile from "./TechProfile";

function App() {
  return (
    <LanguageProvider>
    <BrowserRouter>
      <div className="App">
        <Navigationbar />
        <Snowfall />

        <Routes>
          {/* Home page */}
          <Route
            path="/"
            element={
              <>
                <Social />
                <Apps />
              </>
            }
          />

          {/* Skills / Technical Profile page */}
          <Route path="/skills" element={<TechProfile />} />

          {/* Contact page */}
          <Route path="/contact" element={<Contact />} />

          {/* Fallback → Home */}
          <Route path="*" element={<Social />} />
        </Routes>
      </div>
    </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
